import React from 'react';
import { Flex, Spinner, Text } from '@chakra-ui/react';

export default function AISummaryLoading({ message = 'Generating AI summary...' }) {
  return (
    <Flex align="center" gap={3} bg="blue.50" border="2px solid #3182ce" borderRadius="md" p={3} minH="60px">
      <Spinner size="lg" color="blue.400" thickness="4px" speed="0.7s" />
      <Text color="blue.600" fontWeight="bold" fontSize="lg">{message}</Text>
    </Flex>
  );
} 